export default function CoralSpringsHeroSection() {
  return (
    <section className="relative min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Scenic%20suburban%20neighborhood%20street%20with%20red%20tiled%20roof%20buildings%20and%20palm%20trees%20under%20blue%20sky%20in%20Coral%20Springs%20Florida%20aerial%20view%20bright%20daylight%20residential%20community%20lush%20greenery%20wide%20angle%20photography&width=1920&height=700&seq=cs-hero-1&orientation=landscape')",
        }}
      ></div>
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <h1 className="font-serif text-4xl md:text-6xl font-bold text-white mb-5 leading-tight">
          Emergency Passport &<br />Expedited Services in Coral Springs, FL
        </h1>
        <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto mb-8 leading-relaxed">
          As fast as 24 hours. Trusted by Coral Springs families, professionals, and travelers throughout northwest Broward County.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Your Passport Fast <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white font-semibold text-base px-6 py-4 rounded-md transition-all backdrop-blur-sm whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> 877-253-0084
          </a>
        </div>
        <p className="text-white/50 text-xs mt-5 max-w-xl mx-auto">
          Serving Coral Springs, Parkland, Margate, Coconut Creek, Tamarac, North Lauderdale & surrounding Broward County communities.
        </p>
      </div>
    </section>
  );
}